/**
 * title: string
 * options: [{ title: string, leftIcon: React.ReactNode, rightIcon: React.ReactNode, onClick: () => void, loading: boolean }]
 */

import { useState } from 'react';
import clsx from 'clsx';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { SpinnerGap } from '@phosphor-icons/react';

const MultiOptionDropdown = ({ title = '', options = [] }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-backgroundGrey rounded-xl w-full overflow-hidden">
      <div
        className="flex items-center justify-between cursor-pointer p-4 select-none"
        onClick={() => setIsOpen(!isOpen)}>
        <p className="text-lg font-semibold">{title}</p>
        <ChevronDownIcon
          className={clsx('w-5 h-5 transition-transform duration-150', { 'rotate-180': isOpen })}
        />
      </div>

      {isOpen && (
        <div className="flex flex-col gap-2 bg-genericGray-300">
          {options.map((option) => (
            <div
              key={option.title}
              className={clsx(
                'relative flex items-center justify-between p-4 gap-2 select-none cursor-pointer',
                { 'cursor-not-allowed': option.loading }
              )}
              onClick={() => (!option.loading ? option.onClick && option.onClick() : undefined)}>
              {option.loading && option.leftIcon ? (
                <SpinnerGap className="w-5 h-5 text-genericGray-400 animate-spin" />
              ) : (
                option.leftIcon && option.leftIcon
              )}
              <p className="text-lg font-normal text-genericGray-400">{option.title}</p>
              {option.loading && option.rightIcon ? (
                <SpinnerGap className="w-5 h-5 text-genericGray-400 animate-spin" />
              ) : (
                option.rightIcon && option.rightIcon
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MultiOptionDropdown;
